<template>
  <div class="common-detail">
    <div class="title">{{detail.title}}</div>
    <div class="detail">
      <span>添加时间:{{detail.add_time | parseTime('{y}-{m}-{d}')}}</span>
      <span>作者:{{detail.issuer}}</span>
      <span>来源:国家海洋标准计量中心</span>
      <span>阅读次数:{{detail.views}}</span>
    </div>
    <div class="article-content ql-editor" v-html="detail.content">
      
    </div>
    <div class="article-content">
      <div v-for="(item,index) in detail.file_url" :key="index">
        <a :href="item.url">{{item.name}}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["detail"]
};
</script>

<style scoped>
.common-detail .title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  line-height: 35px;
}
.common-detail .detail {
  font-size: 0;
  text-align: center;
  margin-bottom: 30px;
}
.common-detail .detail > span {
  font-size: 14px;
  margin: 0 10px;
}
.article-content {
  font-size: 16px;
  line-height: 30px;
}
.article-content a{
    color: blue;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
}
.article-content a:hover{
    border-bottom: 1px dashed blue;
}
.article-content p {
    color: #222;
  margin-bottom: 20px;
}
.article-content img {
  max-width: 100%;
  display: block;
  margin: 0 auto 20px;
}
</style>




// WEBPACK FOOTER //
// src/components/views/common/fileDown.vue